<template>
    <b-col id="col-loader">
        <div class="loader-modal">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
            <p>Cargando...</p>
        </div>
        <div class="cover"></div>
    </b-col>
</template>

<script>
    export default {
        name: 'loader'
    }
</script>

<style lang="scss" scoped>
    #col-loader {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
        margin-left: -60px; /* Component Parent margin fix */
        z-index: 100;
        
        .cover {
            position: absolute;
            width:100%;
            top: 0;
            bottom: 0;
            background: rgba(1, 1, 1, .7);
            z-index: 1000;
        }

        .loader-modal {
            position: relative;
            width: 100px;
            height: 80px;
            margin: 50px auto 0 auto;
            z-index: 10000000;
            -webkit-border-radius: 8px;
            -moz-border-radius: 8px;
            border-radius: 8px;
            background-color: #fff;
            text-align: center;
            padding: 14px 10px 0px 10px;
        }
    }
    
</style>